import { TOOLBAR_ITEM_TYPE } from "../../Toolbar";
export function toolbarSeparator(config) {
    return function () { return ({
        type: TOOLBAR_ITEM_TYPE.separator,
        text: config === null || config === void 0 ? void 0 : config.title,
        isAction: config === null || config === void 0 ? void 0 : config.isAction
    }); };
}
//# sourceMappingURL=toolbarSeparator.js.map